/**
 * Created by Ondra on 19.10.2016.
 */
import React from 'react';

import Currency from '../components/numbers/Currency'
import {countDiscountPriceWithoutRound} from '../../common/lib/util';
import Percent from '../components/numbers/Percent';

class ProductRow extends React.Component {

    static propTypes = {
        item: React.PropTypes.object.isRequired,
        marked: React.PropTypes.bool,
        onClick: React.PropTypes.func,
        isTable: React.PropTypes.bool,
        activeClass: React.PropTypes.string,
        addClass: React.PropTypes.string,
        showPriceByPc: React.PropTypes.bool,
        showDiscount: React.PropTypes.bool,
        discount: React.PropTypes.number
    };

    render() {
        const {
            item, marked, onClick, isTable, activeClass, addClass, showPriceByPc, showDiscount, discount
        } = this.props;

        const cur = 'CZK';
        const price = item.get('price') * item.get('pcs');
        const activeClassName = !!activeClass ? activeClass : 'active';
        const d = discount === null || typeof discount === 'undefined' ? 0 : discount;

        return (
            <div className={`productRow row ${marked ? activeClassName : ''} item-${item.get('id')} ${!!addClass ? addClass : ''}`}
                 data-id={item.get('id')}
                 data-table={!!isTable}
                 onClick={() => onClick(item.get('id'), !!isTable)}>
                <span className="productRow-pcs"> {item.get('pcs')} </span>
                <span className="productRow-name">
                    &nbsp;
                    {item.get('name')}
                    &nbsp;
                    {!!showPriceByPc && '('}
                    {!!showPriceByPc &&
                    <Currency currency={cur} value={item.get('price')}/>
                    }
                    {!!showPriceByPc && ')'}
                </span>
                {!!showDiscount &&
                <span className="productRow-price view-original">
                    <Currency currency={cur} value={countDiscountPriceWithoutRound(price, d)}/>
                </span>
                }
                {!!showDiscount &&
                <span className="productRow-price view-discount">
                    <span><Percent value={d}/></span>
                </span>
                }
                <span className={`productRow-price price ${!!showDiscount && 'view-discounted'}`}>
                    {!!showDiscount &&
                    <Currency currency={cur} value={price}/>
                    }
                    {!showDiscount &&
                    <Currency currency={cur} value={price}/>
                    }
                </span>
            </div>
        );
    }

}

export default ProductRow;



// WEBPACK FOOTER //
// ./src/browser/paymentPopup/ProductRow.js